// @flow
import JQueryView, { on } from '../../common/JQueryView';
import flashMessage from '../../../utils/flashMessage';

declare var $: any;

export default class ShowView extends JQueryView {
  constructor(minuteModal: string) {
    super('.company.stockholder_meetings.show');
    this.setStockholderTable();
    if (minuteModal == 'true') $('#minute_modal').modal('show');
  }

  @on({ event: 'change', selector: '.filter-select' })
  onChangeFilter() {
    $('.stockholder-search-form').submit();
  }

  @on({ event: 'click', selector: '.copy-button' })
  copyUrlToClipboard() {
    const url = $('#convocation-url').val();
    navigator.clipboard.writeText(url);
    flashMessage('回答リンクをコピーしました', 'success');
  }

  setStockholderTable() {
    const fixed01 = $('.fixed01');
    const fixed02 = $('.fixed02');
    const fixed03 = $('.fixed03');
    const fixed04 = $('.fixed04');
    const fixed05 = $('.fixed05');
    fixed01.css('left', 0);
    fixed02.css('left', fixed01.innerWidth());
    fixed03.css('left', fixed01.innerWidth() + fixed02.innerWidth());
    fixed04.css(
      'left',
      fixed01.innerWidth() + fixed02.innerWidth() + fixed03.innerWidth(),
    );
    fixed05.css(
      'left',
      fixed01.innerWidth() +
        fixed02.innerWidth() +
        fixed03.innerWidth() +
        fixed04.innerWidth(),
    );
  }
}
